import { useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from '../pages/Loader'

const TripAddAccomodation = ({trip, onAddAccomodation}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [accomodation_name, setAccomodationName] = useState("") 
    const [accomodation_address, setAccomodationAddress] = useState("")
    const [accomodation_link, setAccomodationLink] = useState("") 
    const [checkin_date, setCheckinDate] = useState("")
    const [checkin_time, setCheckinTime] = useState("") 
    const [checkout_date, setCheckoutDate] = useState("") 
    const [checkout_time, setCheckoutTime] = useState("") 
    const [additional_details, setAdditionalDetails] = useState("")
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)


    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!user) {
            return
        }
        setIsLoading(true)
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/accomodation/` , {
            method: 'POST',
            body: JSON.stringify({trip_id: trip._id, accomodation_name, accomodation_address, accomodation_link, checkin_date, checkin_time, checkout_date, checkout_time, additional_details}),
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        })
        const json = await response.json() 
        
        if (!response.ok) {
            setError(json.error)
            setIsLoading(false)
        }

        if (response.ok) {
            setError(null)
            console.log('Accomodation added')
            dispatch({type: 'CREATE_ACCOMODATION', payload: json})
            setIsLoading(false)
            onAddAccomodation("details")
        }
    
    }   

    if (isLoading) {
        return <Loader />
    }
    
    return (
        <form className="add-accomodation-page" onSubmit={handleSubmit}>
            <h3>Add Accomodation</h3>
            <div className="accomodation-inputs">
                <div className="two-input-container">
                    <div className="input-container">
                        <label htmlfor="accomodation_name" class="accomodation-name-input">* Accommodation Name</label>
                        <input id="accomodation_name" class="accomodation-name-input" type="text" onChange={(e) => setAccomodationName(e.target.value)} value={accomodation_name} />
                    </div>
                    <div className="input-container">
                        <label htmlfor="accomodation_address" class="accomodation-address-input">* Accomodation Address</label>
                        <input id="accomodation_address" class="accomodation-address-input" type="text" onChange={(e) => setAccomodationAddress(e.target.value)} value={accomodation_address} />
                    </div>
                </div>
                <div className="two-input-container">
                    <div className="input-container outer-date-time-container">
                        <div className="date-time-input-container">
                            <label htmlfor="checkin_date" class="label-date-time-input">* Check-in Date</label>
                            <input id="checkin_date" class="label-date-time-input date-input" type="date" onChange={(e) => setCheckinDate(e.target.value)} value={checkin_date} />
                        </div>
                        <div className="date-time-input-container">
                            <label htmlfor="checkin_time" class="label-date-time-input">Check-in Time</label>
                            <input id="checkin_time" class="label-date-time-input time-input" type="time" onChange={(e) => setCheckinTime(e.target.value)} value={checkin_time} />
                        </div>
                    </div>
                    <div className="input-container outer-date-time-container">
                        <div className="date-time-input-container">
                            <label htmlfor="checkout_date" class="label-date-time-input">* Check-out Date</label>
                            <input id="checkout_date" class="label-date-time-input date-input" type="date" onChange={(e) => setCheckoutDate(e.target.value)} value={checkout_date} />
                        </div>
                        <div className="date-time-input-container">
                            <label htmlfor="checkout_time" class="label-date-time-input">Check-out Time</label>
                            <input id="checkout_time" class="label-date-time-input time-input" type="time" onChange={(e) => setCheckoutTime(e.target.value)} value={checkout_time} />
                        </div>
                    </div>
                </div>
                <div className="two-input-container">
                    <div className="input-container">
                        <label htmlfor="accomodation_link" class="accomodation-link-input">Accommodation Link</label>
                        <input id="accomodation_link" class="accomodation-link-input" type="text" onChange={(e) => setAccomodationLink(e.target.value)} value={accomodation_link} />
                    </div>
                    <div className="input-container">
                        <label htmlfor="additional_notes" class="accomodation-details-label">Additional Details</label>
                        <textarea id="additional_notes" class="accomodation-details-input" onChange={(e) => setAdditionalDetails(e.target.value)} value={additional_details}></textarea>
                    </div>
                </div>
                <div className="form-buttons">
                    <button type="submit" class="add-accomodation-btn">Add Accomodation</button>
                    <button type="button" class="cancel-add-accomodation-btn" onClick={() => onAddAccomodation("details")}>Cancel</button>
                </div>
            </div>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default TripAddAccomodation

